import { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Table,
  Card,
  Form,
  Badge,
  Spinner,
} from "react-bootstrap";
import { server } from "../../common";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { useSelectAccess } from "../../store/stateFunctions";
import * as XLSX from "xlsx";
import { FaFileExport, FaChartBar, FaClipboardList } from "react-icons/fa";

const TableDashboard = ({ role }) => {
  const [selectedDivision, setSelectedDivision] = useState("All");
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [approved, setApproved] = useState([]);
  const user = useSelectAccess(role);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    server
      .get(`/dashboard/userdashboard`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setData(response.data.departments);
          setApproved(response.data.totals);
        }
      })
      .catch((error) => {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else {
          toast.error(error.response?.data?.error || "An error occurred");
        }
      })
      .finally(() => setLoading(false));
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dashboard");
    XLSX.writeFile(workbook, "Dashboard.xlsx");
  };

  return (
    <Container fluid className="py-2">
      <Card className="shadow-sm border-0 mb-4">
        <Card.Body>
          <Row className="align-items-center mb-4">
            <Col>
              <h2 className="mb-0 fw-bold text-primary">Schemes Dashboard</h2>
              <p className="text-muted mb-0">
                Overview of all scheme applications and their statuses
              </p>
            </Col>
            <Col xs="auto">
              <button
                className="btn btn-primary"
                onClick={exportToExcel}
                disabled={loading}
              >
                <FaFileExport className="me-2" />
                Export to Excel
              </button>
            </Col>
          </Row>

          {/* Stats Summary Cards */}
          <Row className="mb-4">
            <Col md={3}>
              <Card className="border-0 shadow-sm bg-light">
                <Card.Body className="text-center">
                  <h6 className="text-muted mb-2">Total Applications</h6>
                  <h3 className="mb-0 fw-bold text-primary">
                    {loading ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      data.reduce((sum, item) => sum + item.Total, 0)
                    )}
                  </h3>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3}>
              <Card className="border-0 shadow-sm bg-light">
                <Card.Body className="text-center">
                  <h6 className="text-muted mb-2">Approved</h6>
                  <h3 className="mb-0 fw-bold text-success">
                    {loading ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      approved.Approved || 0
                    )}
                  </h3>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3}>
              <Card className="border-0 shadow-sm bg-light">
                <Card.Body className="text-center">
                  <h6 className="text-muted mb-2">Pending</h6>
                  <h3 className="mb-0 fw-bold text-warning">
                    {loading ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      approved.Pending || 0
                    )}
                  </h3>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3}>
              <Card className="border-0 shadow-sm bg-light">
                <Card.Body className="text-center">
                  <h6 className="text-muted mb-2">Rejected</h6>
                  <h3 className="mb-0 fw-bold text-danger">
                    {loading ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      approved.Rejected || 0
                    )}
                  </h3>
                </Card.Body>
              </Card>
            </Col>
          </Row>

        
        </Card.Body>
      </Card>

      
    </Container>
  );
};

export default TableDashboard;
